import { render, staticRenderFns } from "./DataAnalysisHistory.vue?vue&type=template&id=0ca41336&scoped=true&"
import script from "./DataAnalysisHistory.vue?vue&type=script&lang=js&"
export * from "./DataAnalysisHistory.vue?vue&type=script&lang=js&"
import style0 from "./DataAnalysisHistory.vue?vue&type=style&index=0&id=0ca41336&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca41336",
  null
  
)

export default component.exports